module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-04-f988b9213afc444aa5e62c8719bc912b.svg";